function safeTrim(value) {
  if (value === null || value === undefined) return '';
  return String(value).trim();
}

function normalizeSpaces(str) {
  return safeTrim(str).replace(/\s+/g, ' ').trim();
}

function isNumericToken(token) {
  const t = safeTrim(token);
  if (!t) return false;
  return /^\d+$/.test(t);
}

function maskPartFixedStars(part, shown = 2, stars = 3) {
  const p = safeTrim(part);
  if (!p) return '';

  if (isNumericToken(p)) return p;

  if (p.length <= shown) return p;
  return p.slice(0, shown) + '*'.repeat(stars);
}

export function maskFullNameForShopify(fullName) {
  const s = normalizeSpaces(fullName);
  if (!s) return '';

  const parts = s.split(' ').filter(Boolean);
  if (parts.length === 0) return '';

  const numericTail = [];
  let i = parts.length - 1;
  while (i >= 0 && isNumericToken(parts[i])) {
    numericTail.unshift(parts[i]);
    i--;
  }

  const namePartsAll = parts.slice(0, i + 1);

  if (namePartsAll.length === 0) {
    return parts.join(' ');
  }

  if (namePartsAll.length === 1) {
    const maskedSingle = maskPartFixedStars(namePartsAll[0], 2, 3);
    return [...[maskedSingle], ...numericTail].join(' ').trim();
  }

  const lastName = namePartsAll[namePartsAll.length - 1];
  const firstNames = namePartsAll.slice(0, -1);

  const maskedNames = firstNames
    .map((p) => maskPartFixedStars(p, 2, 3))
    .filter(Boolean)
    .join(' ');

  const maskedLast = maskPartFixedStars(lastName, 2, 2);

  return [...[`${maskedNames} ${maskedLast}`.trim()], ...numericTail]
    .join(' ')
    .trim();
}

export const getFormattedTitle = (originalTitle, apiUserType, dataJSON) => {
    if (!originalTitle) {
      return originalTitle;
    }
    if(apiUserType === 'kargoist') {      
      return originalTitle.replace(/Kargoist/i, 'CargoX');
    }
    const prefix = 'Shopify - ';
    if(apiUserType === 'shopify' && originalTitle.startsWith(prefix)) {
      const rest = originalTitle.replace(prefix, '');
      const parts = rest.split(' ');
      let suffix = '';
      let orderNo = '';

      if (parts[parts.length - 1] === 'Siparişi') {
        suffix = parts.pop();  
        orderNo = parts.pop(); 
      } else {
        orderNo = parts.pop();
      }

      const nameSurname = parts.join(' ');
      const maskedName = maskFullNameForShopify(nameSurname); 
      const domainName = dataJSON?.domain || '';
      
      return `${domainName} ${maskedName} ${orderNo} ${suffix}`.trim();
    }
    return originalTitle;
  };

/* ---------------- PHONE ---------------- */

function normalizeTRPhoneDigits(input) {
  const raw = safeTrim(input);
  if (!raw) return '';

  let digits = raw.replace(/\D/g, '');
  if (!digits) return '';

  if (digits.startsWith('90')) digits = digits.slice(2);
  if (digits.startsWith('0')) digits = digits.slice(1);
  if (digits.length > 10) digits = digits.slice(-10);

  return digits;
}

export function maskPhoneTR(input) {
  const digits = normalizeTRPhoneDigits(input);

  if (digits && digits.length === 10) {
    const p1 = digits.slice(0, 3);
    const p4 = digits.slice(8, 10);
    return `${p1} *** ** ${p4}`;
  }

  const raw = safeTrim(input);
  if (!raw) return '';

  const fallbackDigits = raw.replace(/\D/g, '');
  if (fallbackDigits.length <= 4) return raw;

  const first3 = fallbackDigits.slice(
    0,
    Math.min(3, fallbackDigits.length - 2)
  );
  const last2 = fallbackDigits.slice(-2);
  return `${first3} *** ** ${last2}`;
}
